<template>
    <svg ref="self" style="position: absolute; top: 0; width: 100%; height: 100%; fill: transparent; stroke-width: 2px;; z-index: -1; left: 0;">
        <path v-for="line in lines" :key="line" :d="line.d" :style="{stroke: line.stroke}"/>
    </svg>
</template>

<script>
export default {
    data(){
        return{
            lines: [],
            isDraw: true
        }
    },
    methods:{
        getLine(startEl, endEl, stroke){
            if (!this.$refs.self) {
                return
            }
            const refX = this.$refs.self.getBoundingClientRect().left
            const refY = this.$refs.self.getBoundingClientRect().top
            const start = startEl.getBoundingClientRect()
            const startX = start.right - refX
            const startY = (start.top + start.bottom) / 2 - refY
            const end = endEl.getBoundingClientRect()
            const endX = end.left - refX
            const endY = (end.top + end.bottom) / 2 - refY
            return {d: `M ${startX} ${startY} 
                    C ${startX + 15} ${startY} 
                    ${startX + 15} ${endY} 
                    ${endX} ${endY}`, stroke: stroke} /* '#bdc1c6' */
        },
        drawLines(){
            const lines = []
            const lineStartEls = document.querySelectorAll("[lineStart]")

            lineStartEls.forEach((startEl) => {
                const lineStartId = startEl.getAttribute("lineStart")
                const lineEndEls = document.querySelectorAll(`[lineEnd="${lineStartId}"]`) /* ${lineStartId} */
                lineEndEls.forEach((endEl, index) => {
                    const stroke = startEl.getAttribute("lineColor") || endEl.getAttribute("lineColor") || '#bdc1c6'
                    const line = this.getLine(startEl, endEl, stroke);
                    lines.push(line)
                })
            })
            if (JSON.stringify(this.lines) !== JSON.stringify(lines)) {
                this.lines = lines
            }
        }
    },
    mounted(){
        const draw = () => {
            this.drawLines()
            if (this.isDraw) {
                requestAnimationFrame(draw)
            }
        }
        draw();
    },
    unmounted(){
        this.isDraw = false
    }
}
</script>